import { apiCallGetUsersAdminComments } from "../../../api/user-api/api-call-get-user-admin-comments";
import getCorePopUpStore from "../../core/core-popup-store";

const getAdminUserComments = async (userID: number, limit: number) => {
  try {
    const { data, status, code } = await apiCallGetUsersAdminComments({
      userID,
      limit
    });
    if (status === "OK") {
      return data;
    }
    getCorePopUpStore().showAlertMessage(code);
    return code;
  } catch (error) {
    return error;
  }
};

export default getAdminUserComments;
